// HOC shared by both register and account flows
import { withEditPickupPersonForm } from 'components/account/PickupPeople/Edit'

// presentational component
import UI from './UI'

// in reg flow, redirect to pickup people list
export default withEditPickupPersonForm({
  redirect: '/pickup_people'
})(UI)
